module.exports = new Promise((resolve, reject) => {
          // Wait for config to be available
          const checkConfig = () => {
            const configUrl = window.__RUNTIME_CONFIG__?.REACT_APP_NPAAS_REMOTE_ENTRY_URL;
            
            if (!configUrl) {
              // Fallback to build-time env var if runtime config not available
              const fallbackUrl = 'adrinWebApp@https://sb.ngagecpaas.com/remoteEntry.js';
              if (fallbackUrl && fallbackUrl !== 'undefined') {
                return loadRemote(fallbackUrl, resolve, reject);
              }
              reject(new Error('Remote URL not configured'));
              return;
            }
            
            loadRemote(configUrl, resolve, reject);
          };
          
          function loadRemote(url, resolve, reject) {
            // Parse the URL format: "name@url"
            const [name, remoteUrl] = url.split('@');
            
            // Check if already loaded
            if (window[name]) {
              resolve(window[name]);
              return;
            }
            
            // Dynamically load the remote
            const script = document.createElement('script');
            script.src = remoteUrl;
            script.onerror = () => {
              reject(new Error(`Failed to load remote: ${remoteUrl}`));
            };
            script.onload = () => {
              // Register the remote
              const proxy = {
                get: (request) => window[name].get(request),
                init: (arg) => {
                  try {
                    return window[name].init(arg);
                  } catch (e) {
                    console.error('Failed to initialize remote', e);
                  }
                }
              };
              resolve(proxy);
            };
            document.head.appendChild(script);
          }
          
          // Check if config is already loaded
          if (window.__RUNTIME_CONFIG__) {
            checkConfig();
          } else {
            // Wait for config to load
            window.addEventListener('runtime-config-loaded', checkConfig);
            
            // Timeout fallback
            setTimeout(() => {
              if (!window.__RUNTIME_CONFIG__) {
                console.warn('Runtime config not loaded, using fallback');
                checkConfig();
              }
            }, 5000);
          }
        });